import { el } from '../lib/dom.js';
import { NATURES, STAT_LABEL } from '../data/natures.js';

export function NaturesView() {
  const view = el('section', { class: 'view lookup' });
  view.append(
    el('nav', { class: 'lookup__nav' }, el('a', { class: 'link', href: '#/team' }, '‹ Team')),
    el(
      'header',
      { class: 'view__header' },
      el('h1', {}, 'Natures'),
      el(
        'p',
        {},
        'Each nature raises one stat by 10% and lowers another by 10%. HP is never affected; five natures are neutral.',
      ),
    ),
    el(
      'div',
      { class: 'natures' },
      el(
        'div',
        { class: 'natures__row natures__row--head' },
        el('span', {}, 'Nature'),
        el('span', { class: 'natures__up' }, '▲ raises'),
        el('span', { class: 'natures__down' }, '▼ lowers'),
      ),
      ...NATURES.map((n) => {
        const neutral = n.up === n.down;
        return el(
          'div',
          { class: `natures__row${neutral ? ' is-neutral' : ''}` },
          el('span', { class: 'natures__name' }, n.name),
          el('span', { class: 'natures__up' }, neutral ? '—' : STAT_LABEL[n.up]),
          el('span', { class: 'natures__down' }, neutral ? '—' : STAT_LABEL[n.down]),
        );
      }),
    ),
  );
  return view;
}
